export enum Channel {
    VOICE = 'VOICE',
    CHAT = 'CHAT',
}
